import { Wizard } from '../../../components/Wizard/Wizard';
import { ResetPassword } from '../ResetPassword/ResetPassword';
import { ResetPasswordSuccess } from '../ResetPasswordSuccess/ResetPasswordSuccess';

export default function ResetPasswordWizard() {
  return <Wizard steps={[ResetPassword, ResetPasswordSuccess]} wrapperStyle={{ overflow: 'hidden' }} />;
}
